import type { Character } from "@vinyl/shared";

export interface PresencePlayer {
  id: string;
  name: string;
}

export type Screen =
  | { kind: "boot" }
  | { kind: "auth_email"; submitting: boolean; error?: string; resumingToken?: string }
  | { kind: "auth_otp"; email: string; submitting: boolean; error?: string; devCode?: string; rememberMe: boolean }
  | { kind: "char_create"; submitting: boolean; error?: string }
  | { kind: "in_game"; character: Character; online: PresencePlayer[] };

export interface AppState {
  connected: boolean;
  screen: Screen;
}

type Listener = (state: AppState) => void;

export class Store {
  private state: AppState = {
    connected: false,
    screen: { kind: "boot" },
  };
  private readonly listeners = new Set<Listener>();

  get(): AppState {
    return this.state;
  }

  set(patch: Partial<AppState>): void {
    this.state = { ...this.state, ...patch };
    for (const l of this.listeners) l(this.state);
  }

  setScreen(screen: Screen): void {
    this.set({ screen });
  }

  subscribe(fn: Listener): () => void {
    this.listeners.add(fn);
    return () => this.listeners.delete(fn);
  }
}
